import { configureStore } from '@reduxjs/toolkit'

import reducer from './reducers'
import { reduxBatch } from '@manaflair/redux-batch'

import { createQuery, createGraphicDataLegacy, gaEvents } from './middlewares'
import { populateAppState, saveAppState } from '../common/fns'

import throttle from 'lodash/throttle'

const makeStore = (preloadedState) => {
  const store = configureStore({
    reducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(createQuery, createGraphicDataLegacy, gaEvents),
    enhancers: [reduxBatch],
    preloadedState,
  })

  store.subscribe(
    throttle(() => {
      const appState = populateAppState(store.getState())
      saveAppState(appState)
    }, 1000),
  )

  return store
}

export default makeStore
